import {ContentEditableEditorDecoration, ContentEditableEditorPlugin} from '@frontapp/editor-html';
import _ from 'lodash';

import {
  isSearchModifierToken,
  isValidSearchModifierToken,
  splitSearchQuery,
} from '../../../../../../srcCommon/inboxes/search/searchQueryHelpers';

/*
 * Types.
 */

export interface SearchTokenPluginOptions {
  className: string;
  hasTicketIdsFeature?: boolean;
}

/*
 * Plugin.
 */

export function createSearchTokenPlugin(options: SearchTokenPluginOptions): ContentEditableEditorPlugin {
  return {
    decorateText: (text) => decorateText(text, options),
  };
}

function decorateText(
  text: string,
  options: SearchTokenPluginOptions,
): Array<ContentEditableEditorDecoration> {
  const parts = splitSearchQuery(text, options.hasTicketIdsFeature);
  const {className} = options;

  return _(parts)
    .map(({token, startOffset, endOffset}) => {
      if (!token || !isSearchModifierToken(token, options.hasTicketIdsFeature)) {
        return undefined;
      }

      return {
        index: startOffset,
        length: endOffset - startOffset,
        className: isValidSearchModifierToken(token) ? className : '',
        shouldDisableSpellcheck: true,
      };
    })
    .compact()
    .value();
}
